import { useContext } from 'react';
import { ProjectContext, type ProjectContextValue } from '@/components/projects/ProjectContext';

export function useProjects(): Pick<
  ProjectContextValue,
  'projects' | 'loading' | 'error' | 'refreshProjects'
> {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProjects must be used within a ProjectProvider');
  }
  return {
    projects: context.projects,
    loading: context.loading,
    error: context.error,
    refreshProjects: context.refreshProjects,
  };
}
